import { type RouteDefinition, Router } from '@solidjs/router'
import { QueryClient, QueryClientProvider } from '@tanstack/solid-query'
import { type Component, onMount } from 'solid-js'
import { ServiceRegistry } from 'solid-services'
import Container from './core/layout/Container'
import SignIn from './routes/auth/SignIn'

import { attachDarkModeToHtml } from '@components'
import { Glasses, Scale, Scroll } from 'lucide-solid'
import { initApp } from './core/startup/initApp'
import adminRoutes from './routes/Admin/routes'
import chatRoutes from './routes/Chat/routes'
import coursesRoutes from './routes/Courses/routes'
import dashboardRoutes from './routes/Dashboard/routes'
import eventsRoutes from './routes/Events/routes'
import goReadRoutes from './routes/GoRead/routes'
import goWatchRoutes from './routes/GoWatch/routes'
import onboardingRoutes from './routes/Onboarding/routes'
import potentialHighQualityRoutes from './routes/PotentialHighQuality/routes'
import recordingsRoutes from './routes/Recordings/routes'
import settingsRoutes from './routes/Settings/routes'
import setupRoutes from './routes/Setups/routes'
import statusRoutes from './routes/Status/routes'
import Callback from './routes/auth/Callback'
import ForgotPassword from './routes/auth/ForgotPassword'
import UpdatePassword from './routes/auth/UpdatePassword'
import updateRoutes from './routes/notifications/routes'
import AppPage from './routes/static/App'
import Brokers from './routes/static/Brokers'
import CodeOfConduct from './routes/static/CodeOfConduct'
import GuidelinesOnSupport from './routes/static/GuidelinesOnSupport'
import HvfDrawTool from './routes/static/HvfDrawTool'
import PrivacyPolicy from './routes/static/PrivacyPolicy'
import Ranks from './routes/static/Ranks'
import StaticContainer from './routes/static/StaticContainer'
import TermsAndConditions from './routes/static/TermsAndConditions'

const routes: RouteDefinition[] = [
  {
    path: '/auth',
    children: [
      { path: '/login', component: SignIn },
      { path: '/forgot-password', component: ForgotPassword },
      { path: '/update-password', component: UpdatePassword },
      { path: '/callback', component: Callback },
    ]
  },
  {
    path: '/static',
    component: StaticContainer,
    children: [
      { path: '/terms-and-conditions', component: TermsAndConditions },
      { path: '/privacy-policy', component: PrivacyPolicy },
      { path: '/guidelines-on-support', component: GuidelinesOnSupport },
      { path: '/code-of-conduct', component: CodeOfConduct },
    ]
  },
  {
    path: '/',
    component: Container,
    children: [
      ...adminRoutes,
      ...onboardingRoutes,
      ...settingsRoutes,
      ...setupRoutes,
      ...chatRoutes,
      ...updateRoutes,
      ...dashboardRoutes,
      ...potentialHighQualityRoutes,
      ...statusRoutes,
      ...eventsRoutes,
      ...recordingsRoutes,
      ...coursesRoutes,
      ...goReadRoutes,
      ...goWatchRoutes,
      {
        path: '/info',
        // Optional: You can reuse StaticContainer here if it just styles prose/text.
        // If StaticContainer has its own public Navbar, you may want to omit it
        // since Container already provides the authenticated Header.
        component: StaticContainer,
        children: [
          { path: '/app', component: AppPage },
          { path: '/hvf-draw-tool', component: HvfDrawTool },
          { path: '/brokers', component: Brokers },
          { path: '/ranks', component: Ranks },
        ]
      }
    ],
  },
  {
    path: '*all',
    component: () => (
      <div style={{ padding: '24px', 'text-align': 'center' }}>
        Not Found
      </div>
    ),
  },
]

export const queryClient = new QueryClient()

const App: Component = () => {
  onMount(() => {
    initApp()
    attachDarkModeToHtml()
  })
  return (
    <QueryClientProvider client={queryClient}>
      <ServiceRegistry>
        {/* <Box bg='bg.default'> */}
        <Router>{routes}</Router>
        {/* </Box> */}
      </ServiceRegistry>
    </QueryClientProvider>
  )
}

export default App
